export const CHANGE_CURRENT_PAGE = 'customGatewaySettings/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'customGatewaySettings/CHANGE_PAGE_SIZE'
export const CREATE_CUSTOM_GATEWAY_SETTING = 'customGatewaySettings/CREATE_CUSTOM_GATEWAY_SETTING'
export const FETCH_CUSTOM_GATEWAY_SETTINGS_LIST = 'customGatewaySettings/FETCH_CUSTOM_GATEWAY_SETTINGS_LIST'
export const FETCH_CUSTOM_GATEWAY_SETTINGS_FOR_OPTIONS =
  'customGatewaySettings/FETCH_CUSTOM_GATEWAY_SETTINGS_FOR_OPTIONS'
export const REMOVE_CUSTOM_GATEWAY_SETTING = 'customGatewaySettings/REMOVE_CUSTOM_GATEWAY_SETTING'
export const UPDATE_CUSTOM_GATEWAY_SETTING = 'customGatewaySettings/UPDATE_CUSTOM_GATEWAY_SETTING'
